export default {
    en: {
        dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'All Events',
        notHaveEvents: 'Not Have Events'
    },
    zh: {
        dayNames: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        format: 'yyyy年MM月',
        fullFormat: 'yyyy年MM月dd日',
        dayEventsTitle: '全部事件',
        notHaveEvents: '没有事件'
    },
    us: {
        dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'MM/yyyy',
        fullFormat: 'MM/dd/yyyy',
        dayEventsTitle: 'All Events',
        notHaveEvents: 'Not Have Events'
    },
    es: {
        dayNames: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'Todos los eventos',
        notHaveEvents: 'Nada'
    },
    'pt-br': {
        dayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'Todos os eventos',
        notHaveEvents: 'Nenhum evento'
    },
    ja: {
        dayNames: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        format: 'yyyy/MM',
        fullFormat: 'yyyy/MM/dd',
        dayEventsTitle: '全てのイベント',
        notHaveEvents: 'イベントはありません'
    },
    ko: {
        dayNames: ['일', '월', '화', '수', '목', '금', '토'],
        monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        format: 'yyyy/MM',
        fullFormat: 'yyyy/MM/dd',
        dayEventsTitle: '모든 이벤트',
        notHaveEvents: '일정이 없습니다'
    },
    fr: {
        dayNames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'Tous les événements',
        notHaveEvents: 'Aucun événement'
    },
    it: {
        dayNames: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
        monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'Tutti gli eventi',
        notHaveEvents: 'Nessun evento'
    },
    ru: {
        dayNames: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        format: 'MM.yyyy',
        fullFormat: 'dd.MM.yyyy',
        dayEventsTitle: 'Все события',
        notHaveEvents: 'События отсутствуют'
    },
    sv: {
        dayNames: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'Alla händelser',
        notHaveEvents: 'Inga händelser'
    },
    de: {
        dayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        format: 'MM/yyyy',
        fullFormat: 'dd.MM.yyyy',
        dayEventsTitle: 'Alle Veranstaltungen',
        notHaveEvents: 'Keine Veranstaltungen'
    },
    vi: {
        dayNames: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
        monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        format: 'MM/yyyy',
        fullFormat: 'dd/MM/yyyy',
        dayEventsTitle: 'Tất cả sự kiện',
        notHaveEvents: 'Không có sự kiện nào'
    }
}



// WEBPACK FOOTER //
// ./src/components/calendar/i18n.js